import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.6 4.794C20.406 1.886 16.934 0 13.017 0h-.029c-1.915 0-3.72.46-5.328 1.257l8.587 14.836L22.6 4.794Z",
  fill: "#FECB00"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "m23.886 6.95-8.193 14.953-.03.05-.028-.05L4.468 3.552A11.957 11.957 0 0 0 .989 12c0 6.628 5.372 12 12 12h.022c6.629 0 12-5.372 12-12 0-1.805-.41-3.515-1.125-5.05Z",
  fill: "#004E95"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }